import {Component, Input} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html'
})
export class CardComponent {
    @Input() item: NavItem;
}
